import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  getCustomerUpgrades(userId) {
    let url = buildUrl(`dashboard/contract/upgrades/${userId}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchShiftWishEntriesEmployee() {
    let url = buildUrl("timetracker/shiftwish/employee/list")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  createShiftWishEntryEmployee(data) {
    let url = buildUrl("timetracker/shiftwish/employee/create")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  changeShiftWishStatus(data) {
    let url = buildUrl("timetracker/shiftwish/status")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  downloadUsersWithoutRoodyList() {
    let url = buildUrl("stats/list/noroody")
    let options = {}
    options.responseType = "blob"
    return axios.get(url, buildOptions(options)).then((res) => res.data)
  },
  fetchAllowedAdminStudios() {
    let url = buildUrl("dashboard/studios")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchCancellationReport(data) {
    let url = "https://app.wellcomefit.ch/api/dashboard/cancellation-report"
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchAllowedTeams() {
    let url = buildUrl("dashboard/teams")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchAllowedTeamStudios() {
    let url = buildUrl("dashboard/teams/for/studio")

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchGroupfitnessDashboardInfosV2(payload) {
    let url = buildUrl("dashboard/gf/infos-v2")
    return axios.post(url, payload, buildOptions()).then((res) => res.data)
  },
  fetchGroupfitnessDashboardInfos(range) {
    let url = buildUrl("dashboard/gf/infos")
    return axios.post(url, range, buildOptions()).then((res) => res.data)
  },
  fetchTrainerDashboardInfos(range) {
    let url = buildUrl("dashboard/trainer/infos")

    return axios.post(url, range, buildOptions()).then((res) => res.data)
  },
  fetchTrainerDashboardInfoDetails(data) {
    let url = buildUrl("dashboard/trainer/infos/detail")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTrainerStatistics(range) {
    let url = buildUrl("dashboard/trainer/statistics") // Neue URL
    return axios.post(url, range, buildOptions()).then((res) => res.data)
  },
  saveTrainerGoalsForMonth(data) {
    let url = buildUrl("dashboard/save/trainer/goals/month")

    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchMontlyStatistcsForStudio(studioID, month) {
    let url = buildUrl("internal/monthly/statistics/" + studioID + "/" + month)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchMontlyStatistcsForStudioRange(studioID, range) {
    let url = buildUrl("internal/monthly/statistics")
    // Sende studioID und range im Body
    return axios.post(url, { studioId: studioID, range: range }, buildOptions()).then((res) => res.data)
  },
  fetchMontlyStatistcsElevenDaysForStudio(studioID, month) {
    let url = buildUrl("/membercard/leadsstats/monthly/center/stats/" + studioID + "/" + month)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchMontlyStatistcsElevenDaysForStudioRange(studioID, range) {
    let url = buildUrl("membercard/leadsstats/monthly/center/stats")
    return axios.post(url, { studioId: studioID, range: range }, buildOptions()).then((res) => res.data)
  },
  fetchMonthlyStatistcsForStudioTerminationsRange(studioID, range) {
    let url = "https://app.wellcomefit.ch/api/internal/monthly/statistics/terminations"
    // Falls du lokal entwickelst, nutze buildUrl, sonst die volle URL wie im Original
    return axios.post(url, { studioId: studioID, range: range }, buildOptions()).then((res) => res.data)
  },
  fetchMonthlyStatistcsForStudioTerminations(studioID, month) {
    let url = "https://app.wellcomefit.ch/api/internal/monthly/statistics/terminations/" + studioID + "/" + month
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchTrainerDashboardInfosSingleTrainer(data) {
    let url = buildUrl("dashboard/trainer/infos/single/trainer")

    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTrainerDashboardInfosStudio(data) {
    let url = buildUrl("dashboard/trainer/infos/studio")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchAnamneseDashboardQuestions(data) {
    let url = buildUrl("dashboard/anamnese/quuestions")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchGFParticipants(visited) {
    let url = buildUrl(`stats/gf/participants/${visited}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchGFCustomerAverage() {
    let url = buildUrl("stats/gf/customer/average")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  reloadDashboardUserStatistics() {
    let url = "https://app.wellcomefit.ch/api/stats/daily/customers"
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchGrowthStatistics(info) {
    let url = buildUrl("stats/growth")
    return axios.post(url, info, buildOptions()).then((res) => res.data)
  },
  fetchContractStatistics(info) {
    let url = buildUrl("stats/contracts")
    return axios.post(url, info, buildOptions()).then((res) => res.data)
  },
  fetchLatestPackageStats() {
    let url = buildUrl("stats/packages/latest")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchDashboardUserStatisticsNew(studios) {
    let url = buildUrl("dashboard/user/statistics/new")
    // let url = "https://app.wellcomefit.ch/api/dashboard/user/statistics/new"
    return axios.post(url, studios, buildOptions()).then((res) => res.data)
  },
  fetchDashboardUserStatistics(studios) {
    let url = buildUrl("dashboard/user/statistics")
    if (location.host.includes("local")) {
      url = buildUrl("dashboard/user/statisticsnew")
    }
    return axios.post(url, studios, buildOptions()).then((res) => res.data)
  },
  fetchContractDevelopment(months) {
    //   let url = "https://app.wellcomefit.ch/api/dashboard/contracts/development"
    let url = buildUrl("dashboard/contracts/development")

    return axios.post(url, months, buildOptions()).then((res) => res.data)
  },
  fetchDashboardUserTACStatistics(studios) {
    let url = ""
    if (location.host.includes("localhost")) {
      url = buildUrl("dashboard/user/tacstatisticsnew")
    } else {
      url = buildUrl("dashboard/user/tacstatistics")
    }

    return axios.post(url, studios, buildOptions()).then((res) => res.data)
  },
  getCustomerContracts(userId) {
    let url = buildUrl(`dashboard/user/contracts/${userId}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getCustomerDocuments(userId) {
    let url = buildUrl(`dashboard/user/documents/${userId}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchDashboardUserInfos() {
    let url = buildUrl("dashboard/user/infos")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  updatePaymentOptionsContract(info) {
    let url = buildUrl("dashboard/contract/paymentoptions/edit")
    return axios.post(url, info, buildOptions()).then((res) => res.data)
  },
  addAttachmentToContract(info) {
    let url = buildUrl("dashboard/contract/attachment/add")
    return axios.post(url, info, buildOptions()).then((res) => res.data)
  },
  fetchContractUserInfos(data) {
    let url = "https://app.wellcomefit.ch/api/dashboard/contracts/infos"
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionStatistics(data) {
    let url = "https://app.wellcomefit.ch/api/dashboard/transactions/infos"
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionSnapshotStateV2() {
    const url = buildUrl("stats/transactions-v2/snapshots/latest")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  importTransactionSnapshotV2(data) {
    const url = buildUrl("stats/transactions-v2/snapshots/import")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionForecastV2(data) {
    const url = buildUrl("dashboard/transactions-v2/forecast")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionForecastDetailsV2(data) {
    const url = buildUrl("dashboard/transactions-v2/forecast/details")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionBusinessForecastV2(data) {
    const url = buildUrl("dashboard/transactions-v2/business-forecast")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionBusinessForecastDetailsV2(data) {
    const url = buildUrl("dashboard/transactions-v2/business-forecast/details")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionCancellationsV2(data) {
    const url = buildUrl("dashboard/transactions-v2/cancellations")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionActualsV2(data) {
    const url = buildUrl("dashboard/transactions-v2/actuals")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionYoyComparisonV2(data) {
    const url = buildUrl("dashboard/transactions-v2/yoy-comparison")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionComparisonV2(data) {
    const url = buildUrl("dashboard/transactions-v2/comparison")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchAdjustmentsSummary(data) {
    let url = "https://app.wellcomefit.ch/api/dashboard/adjustments/summary"
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchYoyComparison(data) {
    let url = "https://app.wellcomefit.ch/api/dashboard/transactions/yoy-comparison"
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionStatisticsDrill(data) {
    let url = "https://app.wellcomefit.ch/api/dashboard/transactions/drilldown"
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchTransactionDetails(data) {
    let url = "https://app.wellcomefit.ch/api/dashboard/transactions/details"
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchContractPackagesStats(data) {
    let url = "https://app.wellcomefit.ch/api/dashboard/contracts/packages-and-total"
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchContractsDevelopment(data) {
    let url = buildUrl("dashboard/contracts/development")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchDashboardCheckinInfos(range, selectedStudios) {
    let url = buildUrl("dashboard/checkin/infos")
    return axios.post(url, { range, selectedStudios }, buildOptions()).then((res) => res.data)
  },
  fetchCheckinStatisticsV2(range, selectedStudios) {
    let url = buildUrl("dashboard/checkin/statistics/v2")
    return axios.post(url, { range, selectedStudios }, buildOptions()).then((res) => res.data)
  },
}
